import React, { useState, useEffect, useCallback } from "react";
import '../../styles/medicineview.scss'
import {
    IconCollectionsBookmark,
    Flex,
    Link,
    useAuthenticator,
    useTheme,
    Tabs,
    TabItem,
    Button,
    SelectField,
    TextField,
    TextAreaField,
} from "@aws-amplify/ui-react";
// import {
//   getProductImage,
//   getAbbrPiByID,
//   getDrugInfo,
//   getFullPiByID,
//   getCMIByID,
//   getPbsDesc,
//   getGenericMonograph,
//   getPILById,
//   getBriefMonoById,
//   getBasicMonoById,
//   getBlueBook
// } from "../services/ProductSearchService";
import {
    getProductImage, getAbbrPiByID,
    getDrugInfo, httpHtml, cleanUpAnchor, getClassLabel, getBriefLabel, getFullPILabel, getPILLabel
} from "../../Services/Utilities.js";

//import Drtc from "./Drtc";
import "@aws-amplify/ui-react/styles.css";

// import {
//   useNavigate,
//   useLocation,
//   useLinkClickHandler,
//   useSearchParams,
// } from "react-router-dom";
// import ArtgModal from "./ArtgModal";
// import RxModal from "./RxModal";
// import PbsInfoModal from "./PbsInfoModal";
// import PregnancyModal from "./PregnancyModal";
// import SportsModal from "./SportsModal";
// import MimsClassModal from "./MimsClassModal";
// import IvCompatibilityModal from "./IvCompatibilityModal";
// import PbsModal from "./PbsModal";
// import ImageModal from "./ImageModal";
// import Interactions from "./Interaction.js";
// import HerbalInteractions from "./HerbalInteraction";
// import Cyp from "./Cyp";
// import Navigation from "./Navigation";
// import Banner from "./Banner";
// import Dental from "./Dental";

import parse from "html-react-parser";
import TableOfContents from "./TableOfContents.js";

//import Modal from "react-bootstrap/Modal";

//import Moment from "moment";

// import jsPDF from "jspdf";
// //import html2canvas from "../html2canvas.js";
// import html2canvas from "html2canvas";
// import jwt_decode from "jwt-decode";
// import Toast from "react-bootstrap/Toast";
// import { ToastContainer } from "react-bootstrap";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// import { logPageView } from "../services/Utilities.js";
// import { loadImagePublic } from "../services/StyleService";
// import e from "cors";
// import BriefMono from "../components/MedicineView/BriefMono.js"
// import FullPI from "../components/MedicineView/FullPI.js";
// import BasicMono from "../components/MedicineView/BasicMono.js";
// import GenericMonograph from "../components/MedicineView/GenericMonograph.js";
// import GenericMonographBrands from "../components/MedicineView/GenericMonographBrands.js";
// import Manufacturer from "./Manufacturer.js";

const AbbreviatedPi = ({ abbrpis, drugInfo, brandId, productImages }) => {


    const [additionalInfo, setAdditionalInfo] = useState("");

    const [mimsRevisionDate, setMimsRevisionDate] = useState("");
    const [boxedWarning, setboxedWarning] = useState("");
    const abbpi_ref = React.useRef(null);

    function DrugNameAndAcgSection() {
        return (
            <div id="DrugName2" className="fluid-transparent">
                <h1>{drugInfo.brandName && parse(drugInfo.brandName)} {drugInfo.offMarket ? '(Discontinued)' : ''}</h1>
                <h4>{drugInfo.activeCompositionGroup?.length > 0
                    && drugInfo.activeCompositionGroup.map((acg, index) => {
                        return (
                            <><a key={index} 
                            // href={"/searchresults?name=" + (encodeURIComponent(acg.acgName))}
                            >
                                {parse(acg.acgName)}
                            </a>{(index + 1) < drugInfo.activeCompositionGroup.length ? parse(`,&nbsp;`) : ''}
                            </>
                        )
                    })
                }
                </h4>
            </div>

        )
    }
    const productDetails = (products) => {
        return (
            products.map(prod => {
                return (
                    <div key={prod.productGroupingName} className="product" >
                        <h2a id={cleanUpAnchor(prod.productGroupingName)} ref={abbpi_ref}>
                            {parse(prod.productGroupingName)}
                            {prod.statusChanged == "Deleted"
                                && parse('<br/><span class="deleted">(Discontinued, '
                                    +
                                    //  ((prod.statusChangedDate).format('MMMM yyyy')) 
                                    +
                                    ')</span>')}
                        </h2a>
                        {prod.poisonRegulation
                            && (prod.poisonRegulation.startsWith('S4') || prod.poisonRegulation.startsWith('S7') || prod.poisonRegulation.startsWith('S8'))
                            && <button type='button'
                                //   onClick={() => setShowRxModal(true)} 
                                className="rx">R<sub>x</sub></button>}
                        {prod.poisonRegulation && prod.poisonRegulation != ""
                            && <span className="poison">&nbsp; {parse('(' + prod.poisonRegulation + ')')}</span>}
                        {prod.isDrowsy &&
                            <div className="drowsy"><Link
                            //   onClick={() => setShowDrowsyModal(true)}
                            >This product may cause drowsiness.</Link></div>
                        }
                        {prod.composition
                            && <p>{parse(prod.composition.replace('\n', '</p><p>'))}</p>}
                        {prod.dose
                            && <div className="dose"><h4>Dose: </h4>
                                <p>
                                    {prod?.pppa && prod.pppa.foodCode != 'Z' &&
                                        <>
                                            {/* <img src={'./pppa/Food-' + (prod.pppa.foodCode) + '.gif'} className='pppa' /> */}
                                            {prod.pppa.description} {prod.pppa.additionalInfo}<br /></>
                                    }
                                    {parse(prod.dose.replace('\n', '<p></p>'))}
                                </p>
                            </div>}
                        {prod.packs?.length > 0 && packDetails(prod.packs)}
                    </div>
                )
            }
            )
        );
    };
    const packDetails = (packs) => {
        return (

            <div>
                {packs.map((pack, index) => {

                    // if(pack.pbsPacks.length ===0) {
                    //   return (

                    //     <div className="packs accordion-item accordion-flush" key={index}>
                    //     <div className="packName" key={index}>
                    //       <button className='accordion-button no-icon'>
                    //       {parse(pack.name)} <span className="artg">{pack.artg}</span>
                    //     </button>
                    //     </div>
                    //     </div>
                    //   )
                    // }
                    // else {
                    return (
                        <Accordion className='packs' disableGutters style={{ marginTop: '10px' }} defaultExpanded={pack.pbsPacks?.length > 0} ex>
                            <AccordionSummary className='packName' expandIcon={pack.pbsPacks?.length > 0 ? <ExpandMoreIcon /> : <></>}  >
                                {parse(pack.name)} <span className="artg">{pack.artg}</span>
                            </AccordionSummary>
                            {pack.pbsPacks && pack.pbsPacks.length > 0 &&
                                <AccordionDetails>
                                    {pbsPackDetails(pack.pbsPacks)}
                                </AccordionDetails>
                            }
                        </Accordion>

                        // <div className="packs accordion-item accordion-flush" key={index}>
                        //   <div className="packName accordion-header">
                        //     <button className="accordion-button accordion-flush " type="button" data-bs-toggle="collapse"
                        //       data-bs-target={'#flush-collapse'+cleanUpAnchor(pack.name)} aria-expanded="true" aria-controls="collapseOne">
                        //       {parse(pack.name)} <span className="artg">{pack.artg}</span>
                        //     </button>
                        //   </div>
                        //     <div className="accordion-collapse show" id={'flush-collapse'+cleanUpAnchor(pack.name)} >
                        //       {pack.pbsPacks && pack.pbsPacks.length > 0 
                        //         ? ( pbsPackDetails(pack.pbsPacks) )
                        //         : ( <hr></hr>)
                        //       }
                        //     </div>
                        // </div>
                    )
                }
                    // }
                )}
            </div>
        );
    };

    const pbsPackDetails = (pbsPacks) => {
        return (
            <table className="pbsPacks">
                <thead>
                    <tr className="pbsPackHeader">
                        <th>Code</th>
                        <th>
                            Max Qty
                            <br />
                            Packs
                        </th>
                        <th>
                            Max Qty
                            <br />
                            Units/ Amount
                        </th>
                        <th>Rp</th>
                        <th>PBS Type</th>
                        <th>Restrictions</th>
                        <th>Price</th>
                    </tr>
                </thead>
                <tbody>
                    {pbsPacks.map((item, index) => {
                        return (
                            <>
                                <tr key={index} className="pbsPack" >
                                    <td>{item.pbsCode}</td>
                                    <td>{item.maxQtyPacks}</td>
                                    <td>{item.maxQtyUnits}</td>
                                    <td>{item.repeats}</td>
                                    <td style={{ textAlign: 'left', verticalAlign: 'middle' }}>
                                        <Link
                                        // onClick={() => setShowPbsInfoModal(true)}
                                        >
                                            <>
                                                {item.rule?.type && <>{item.rule?.type} - </>}
                                                {
                                                    item.pbsProgram?.[0]?.description === "General Schedule" || !item.pbsProgram?.[0]
                                                        ? <>{item.pbsType}</>
                                                        : <>{item.pbsProgram[0].description.replaceAll(item.rule.type, "")}</>
                                                }
                                                {!item.pbsProgram?.[0] || item.restrictionTypes[0] !== 'Unrestricted' && ` - ${item.restrictionTypes[0]}`}
                                            </>
                                        </Link>
                                        {item.prescriberTypes && ` (${item.prescriberTypes.join(",").replaceAll("|", ",")})`}
                                        {item.pbsEquiv && <>
                                            {/* <img src='./Subst.png' style={{ padding: 0, margin: 0 }} 
                    // onClick={() => onShowMimsClassModalClick(drugInfo.mimsClass[0])} 
                    title="PBS Equivalent" /> */}
                                        </>}
                                    </td>
                                    <td className="pbsAuthority"
                                    //   onClick={() => onPbsRuleClick(item.rule?.id)}
                                    >
                                        {item.rule?.id
                                            ? <>
                                                <div key={item.rule?.id} >
                                                    {/* parse(cleanUpPbsTags(pbsTeasers.find((e) => e.id===item.rule.id)?.description)) */}
                                                    {item.rule?.streamlineCode && <div className='sa'>{item.rule?.streamlineCode}</div>}
                                                    {parse(cleanUpPbsTags(item.rule.teaser))}
                                                </div>
                                            </>
                                            : <div className='d-flex justify-content-center'>-</div>
                                        }
                                    </td>
                                    <td>
                                        {item.prices?.pbsPrice && (
                                            <>
                                                {item.prices?.pbsPrice.replace("PBS", "DPMQ")}
                                                <br />
                                            </>
                                        )}
                                        {item.prices?.tgpPrice && (
                                            <>
                                                {item.prices?.tgpPrice} (TGP)
                                                <br />
                                            </>
                                        )}
                                        {item.prices?.bppPrice && (
                                            <>
                                                {item.prices?.bppPrice.replace('[', '').replace(']', '')} (BPP)
                                                <br />
                                            </>
                                        )}
                                    </td>
                                </tr>
                            </>
                        );
                    })}
                </tbody>
            </table>
        );
    };
    function cleanUpPbsTags(input) {
        if (input !== undefined && input !== '' && input !== null) {
            input = input.toString()
                .replace("<SA>", "<div class='sa'>")
                .replace("</SA>", "</div>")
                .replace("Treatment Phase:", "<div class='tp'>Treatment&nbsp;Phase:</div>")
                .split('<br /><br />')
                .join('<br />')

            if (input.indexOf("<br /> <b>") > 0) {
                input = input.substring(0, input.indexOf('<br /> <b>'))
            }
            else {
                input = input + "..."
            }

            return input
        }
        else return ''
    }
    const BrandInfo = () => {
        return (
            <table>
                <tbody>
                    {drugInfo.company?.length > 0 && drugInfo.company[0].companyId &&
                        <tr>
                            <th>Company:</th>
                            <td>
                                <a
                                //   href={
                                //     "/searchresults?type=company&name=" +
                                //     drugInfo.company[0].companyName +
                                //     "&id=" +
                                //     drugInfo.company[0].companyId
                                //   }
                                >
                                    {drugInfo.company[0].companyName}
                                </a>
                                {additionalInfo && <div>{additionalInfo}</div>}
                            </td>
                        </tr>
                    }
                    {drugInfo.mimsClass?.length > 0 && (
                        <tr>
                            <th>MIMS Class:</th>
                            <td>
                                {drugInfo.mimsClass.map((e, index) => {
                                    return (
                                        <>
                                            <a
                                                key={index}
                                            // href={"/searchresults?type=mimsClass&name=" + e}
                                            >
                                                {e}
                                            </a>
                                            {/* <img 
                    //   onClick={() => onShowMimsClassModalClick(e)} 
                      src="more_info.png"
                      /> */}
                                            <br />
                                        </>
                                    );
                                })}
                            </td>
                        </tr>
                    )}
                    {!drugInfo.offMarket &&
                        drugInfo.pregnancyCategory &&
                        drugInfo.pregnancyCategory.pregnancyCode && (
                            <tr>
                                <th>Use in Pregnancy:</th>
                                <td>
                                    {drugInfo.pregnancyCategory.pregnancyCode}{" "}
                                    {/* <img
                    // onClick={() => onShowPregnancyModal()}
                    src="more_info.png"
                  /> */}
                                    {/* <PregnancyModal key={drugInfo.brandId}
                    showPregnancyModal={showPregnancyModal}
                    setShowPregnancyModal={setShowPregnancyModal}
                    preg={drugInfo.pregnancyCategory}
                    brandName={drugInfo.brandName}
                  /> */}

                                </td>
                            </tr>
                        )}
                    {!drugInfo.offMarket &&
                        drugInfo.artg &&
                        drugInfo.artg !== "Medicine Not Registered" && (
                            <tr>
                                <th>ARTG:</th>
                                <td>
                                    {drugInfo.artg}{" "}
                                    {/* <img
                    // onClick={() => onShowArtgModal()}
                    src="more_info.png"
                  /> */}
                                    {/* <ArtgModal
                    showArtgModal={showArtgModal}
                    setShowArtgModal={setShowArtgModal}
                  /> */}
                                    <br />
                                </td>
                            </tr>)
                    }
                    {drugInfo?.brandId &&
                        <tr>
                            <th></th>
                            <td>
                                {/* <button type='button' className='adverse-report-button' onClick={() => window.open("https://aems.tga.gov.au/privacy/", '_blank')}><i className="fa-solid fa-flag fa-sm"></i> Report an Adverse Reaction</button> */}
                            </td>
                        </tr>
                    }
                    {drugInfo?.sports && drugInfo.sports.sportCode &&
                        <tr>
                            <th>Sports:</th>
                            <td>{drugInfo.sports.description} {drugInfo.sports.sportCode != 'P' && drugInfo.sports.sportCode != 'H' &&
                                <>
                                    {/* <img 
                //   onClick={() => setShowSportsModal(true)} 
                  src="more_info.png" /> */}
                                    {/* <SportsModal showSportsModal={showSportsModal} setShowSportsModal={setShowSportsModal} sports={drugInfo.sports} /> */}
                                </>
                            }
                            </td>
                        </tr>
                    }
                    {(mimsRevisionDate) &&
                        <tr>
                            <th>MIMS Revision Date:</th>
                            <td>{(mimsRevisionDate).format("DD MMMM YYYY")}</td>
                        </tr>
                    }
                    {(drugInfo.offMarket) &&
                        <tr>
                            <th>Status</th>
                            <td><span className="deleted">Discontinued,
                                {/* {(drugInfo.statusChangedDate).format('MMMM yyyy')} */}
                            </span></td>
                        </tr>
                    }
                </tbody>
            </table>
        )
    }

    return (
        <>

            <div className="col">
                {drugInfo &&
                    <div className="text-start" id="DrugInfo">
                        <div id="DrugName">
                            <DrugNameAndAcgSection />
                        </div>
                       
                        {/* {drugInfo.offMarket && <BrandInfo />} */}
                    </div>
                }


            </div>

            {abbrpis && (
                <div className="row bg-white" id="PIContainer">
                    <div className="col-lg-3 toc leftpane">
                        {abbrpis.abbreviatedPiId && <TableOfContents key={abbrpis.abbreviatedPiId} levels={2} />}
                    </div>
                    <div className="col-lg-9 rightpane" id="AbbrevPI">

                        {abbrpis.content?.length > 0 &&
                            <div>
                                <h2 id='summary'>
                                    Summary
                                </h2>
                                <div className="row" id="SummarySection">
                                    <div className="col" style={{ minWidth: 450 }}>
                                        <BrandInfo />
                                    </div>
                                    <div className="col"  >
                                        {drugInfo && productImages && productImages.length > 0 &&

                                            <div id="product-images-container" >
                                                <div id="product-images-header">Product Images:&nbsp;<span id='product-images-count'>count: {productImages.length}</span></div>
                                                <div id="product-images">
                                                    {
                                                        productImages.map(item => {
                                                            return (
                                                                <div key={item.imageId} className="product-image-box"
                                                                //   onClick={() => handleImageClick(item)} 
                                                                >
                                                                    <img className="product-image" src={item.imageUrl} />
                                                                    <div className="product-image-name">{item.imageName}</div>
                                                                </div>
                                                            )
                                                        }

                                                        )
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="col">
                                    </div>
                                    
                                </div>
                            </div>
                        }

                        {abbrpis.blackTriangle && abbrpis.blackTriangle !== "false" &&
                            parse("<div><p>" + httpHtml(abbrpis.blackTriangle) + "</p></div>")
                        }
                        {boxedWarning && (
                            <div className="boxedWarning">
                                {parse(boxedWarning)}
                            </div>
                        )}

                        {abbrpis.content?.length > 0 &&
                            abbrpis.content.map((item) => {
                                if (!item.text | (item.text === "")) return <></>;
                                else if (item.header == "Additional Information")
                                    return <></>;
                                else
                                    return (
                                        <div key={item.header}>
                                            <h2
                                                id={cleanUpAnchor(item?.header)}
                                                ref={abbpi_ref}
                                            >
                                                {item?.header}
                                            </h2>
                                            <p>
                                                {item.text &&
                                                    parse(
                                                        httpHtml(item.text.replace(/\n/g, "<br />")
                                                        )
                                                    )}
                                            </p>
                                        </div>
                                    );
                            })}

                        {abbrpis.products?.length > 0 &&
                            <>
                                <h2 id="products">Available Products</h2>
                                {productDetails(abbrpis.products)}
                            </>
                        }

                        {abbrpis.manuPdf && <div className="manufacturerPdf"><h2>Manufacturer's PI</h2><a href={abbrpis.manuPdf} target='_blank'>View Manufacturer's PI </a><i class="fa-solid fa-file-pdf" ></i></div>}

                        {abbrpis.contactManufacturer && <div className="contactManufacturer">For further information contact manufacturer</div>}


                    </div>
                </div>)
            }
        </>
    );
}

export default AbbreviatedPi;